import React from 'react';

import Tab, { TabGroup as TabGroupLib } from '@amzn/meridian/tab';
import Tooltip from '@amzn/meridian/tooltip';
import { useAppSelector } from 'src/store/store';

interface TabGroupProps {
  currentTab: string;
  setCurrentTab: (newTab: string) => void;
}

const TabGroup = ({ currentTab, setCurrentTab }: TabGroupProps) => {
  const {
    activePlacementsTableData,
    expiredPlacementsTableData,
    pendingPlacementsTableData,
    closedPlacementsTableData,
    transferredInPlacementsTableData,
  } = useAppSelector((state) => state.placementOverviewPage);
  const { featureFlags } = useAppSelector((state) => state.user);

  return (
    <TabGroupLib value={currentTab} onChange={setCurrentTab}>
      <Tab value="pendingPlacements">Pending Placements ({pendingPlacementsTableData.length})</Tab>
      <Tab value="expiredPlacements">Expired Placements ({expiredPlacementsTableData.length})</Tab>
      <Tab value="activePlacements">Active Placements ({activePlacementsTableData.length})</Tab>
      <Tab value="closedPlacements">Closed Placements ({closedPlacementsTableData.length})</Tab>
      {featureFlags.PLACEMENT_TRANSFER && transferredInPlacementsTableData.length > 0 && (
        <Tab value="transferredInPlacements">
          <Tooltip
            position="top"
            title="Another site has transferred these placements to your site.
              Note: Filters do not apply to transferred in placements."
          >
            <span>Transferred In Placements ({transferredInPlacementsTableData.length})</span>
          </Tooltip>
        </Tab>
      )}
    </TabGroupLib>
  );
};

export default TabGroup;
